import { render, staticRenderFns } from "./SlidersPage.vue?vue&type=template&id=6fa3fc66&"
import script from "./SlidersPage.vue?vue&type=script&lang=ts&"
export * from "./SlidersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports